import { useSelector } from 'react-redux';
import * as Linq from 'linq';

import { RootState } from '../redux/rootReducer';
import useCurrentUserId from './useCurrentUserId';
import { ImageValueType } from '../components/ImageBrowserDialog';

const useAllImages = (): [string[], ImageValueType[]] => {
  const userId = useCurrentUserId();
  const imageDb = useSelector((state: RootState) => state.imageDb);
  const ruiDb = useSelector((state: RootState) => state.relationUserImageDb);
  const raiDb = useSelector((state: RootState) => state.relationAlbumImageDb);

  if (!userId) return [[], []];

  const idsFromRui = Linq.from(Object.keys(ruiDb.relationUserImages))
    .where(ruiId => ruiDb.relationUserImages[ruiId].userId === userId)
    .select(ruiId => ruiDb.relationUserImages[ruiId].imageId).toArray();

  const idsFromRai = Linq.from(Object.keys(raiDb.relationAlbumImages))
    .orderBy(raiId => raiDb.relationAlbumImages[raiId].order)
    .select(raiId => raiDb.relationAlbumImages[raiId].imageId)
    .where(id => idsFromRui.includes(id)).toArray();

  const idsNotInRai = Linq.from(idsFromRui).where(id => !idsFromRai.includes(id)).toArray();

  const ids = idsNotInRai.concat(idsFromRai);

  const values: ImageValueType[] = [];
  let ix = 0;

  if (!ids) return [ids, values];

  ids.forEach(id => {
    if (Boolean(imageDb.images[id])) {
      values.push({ ...imageDb.images[id], order: ix });
      ix++;
    }
  })

  return [ids, values];
}

export default useAllImages;
